
import web3 from "web3";


export const toWei = (num) => {
    return web3.utils.toWei(num.toString())
}
